import Vue from "vue";
import VueRouter from "vue-router";
import home from '@/view/home/home'

Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        component: home,
        meta: {
            title: "轩卓博客-一个专注于技术分享的博客平台"
        },
        children: [
            {
                path: "/",
                component: resolve => require(["@/view/home/index.vue"], resolve),
                meta: {
                    title: "轩卓博客-一个专注于技术分享的博客平台"
                }
            },
            {
                path: "/map",
                component: resolve => require(["@/view/map/index.vue"], resolve),
                meta: {
                    title: "我的足迹"
                }
            },
            {

                path: "/links",
                component: resolve => require(["@/view/link/index.vue"], resolve),
                meta: {
                    title: "友情链接"
                }
            },
            {
                path: "/article/:articleId",
                component: resolve => require(["@/view/article/index.vue"], resolve),
            },
            {
                path: "/message",
                component: resolve => require(["@/view/message/index.vue"], resolve),
                meta: {
                    title: "留言板"
                }
            },
            {
                path: "/about",
                component: resolve => require(["@/view/about/index.vue"], resolve),
                meta: {
                    title: "关于本站"
                }
            },
            {
                path: "/newposts",
                component: resolve => require(["@/view/article/Add"], resolve),
            },
            {
                path: "/archive",
                component: resolve => require(["@/view/archive/index"], resolve),
                meta: {
                    title: "文章归档"
                }
            },
            {
                path: "/categorys",
                component: resolve => require(["@/view/category/Category.vue"], resolve),
                meta: {
                    title: "文章分类"
                }
            },
            {
                path: "/tag",
                component: resolve => require(["@/view/tag/Tag"], resolve),
                meta: {
                    title: "文章标签"
                }
            },
            {
                path: "/photo",
                component: resolve => require(["@/view/photo/index"], resolve),
                meta: {
                    title: "我的图库"
                }
            },
            {
                path: '/photo/:id',
                name: 'PhotoDetail',
                component: resolve => require(["@/view/photo/detail"], resolve),
                meta: {
                    transition: 'fade',
                    title: '相册详情',
                    icon: 'fas fa-images',
                    hidden: true
                }
            },
            {
                path: '/resources',
                name: 'Resources',
                component: resolve => require(["@/view/resources/index.vue"], resolve),
                meta: {
                    title: '资源'
                }
            },
            {
                path: "/say",
                name: 'Say',
                component: resolve => require(["@/view/say/index"], resolve),
                meta: {
                    title: '说说'
                }
            },
            {
                path: '/say/:id',
                name: 'SayDetail',
                component: resolve => require(["@/view/say/Detail"], resolve),
                meta: {
                    title: '说说详情'
                }
            },
            {
                path: "/add_say",
                component: resolve => require(["@/view/say/Add"], resolve),
                meta: {
                    title: "添加说说"
                }
            },
            {
                path: "/forum",
                component: resolve => require(["@/view/forum/index"], resolve),
                meta: {
                    title: "瞬间"
                }
            },
            {
                path: "/forumInfo",
                component: resolve => require(["@/view/forum/hisForum"], resolve),
                meta: {
                    title: "朋友圈"
                }
            },
            {
                path: "/sponsor",
                component: resolve => require(["@/view/sponsor/index"], resolve),
                meta: {
                    title: "打赏名单"
                }
            },
            {
                path: "/im",
                component: resolve => require(["@/view/im/index"], resolve),
                meta: {
                    title: "轩卓博客-一个专注于技术分享的博客平台"
                }
            },
            {
                path: "/hot",
                component: resolve => require(["@/view/search/Hot.vue"], resolve),
                meta: {
                    title: "网站热搜"
                }
            },
            {
                path: "/note",
                component: resolve => require(["@/view/note/index.vue"], resolve),
                meta: {
                    title: "轩卓博客-一个专注于技术分享的博客平台"
                }
            },
            {
                name: "notice",
                path: "/notice",
                component: resolve => require(["@/view/notice/index.vue"], resolve),
                meta: {
                    title: "轩卓博客-一个专注于技术分享的博客平台"
                }
            },
            {
                path: "/music",
                component: resolve => require(["@/view/music/index.vue"], resolve),
                meta: {
                    title: "音乐盒"
                }
            },
            {
                path: "/navigation",
                component: resolve => require(["@/view/navigation/index.vue"], resolve),
                meta: {
                    title: "网站导航"
                }
            },
            {
                path: "/tools",
                component: resolve => require(["@/view/tools/index.vue"], resolve),
                meta: {
                    title: "工具箱"
                }
            },
            {
                path: "/love",
                component: resolve => require(["@/view/love/index.vue"], resolve),
                meta: {
                    title: "恋爱记"
                }
            },
            {
                path: "/lottery",
                component: resolve => require(["@/view/lottery/index.vue"], resolve),
                meta: {
                    title: "幸运抽奖"
                }
            },
            {
                path: "/user",
                component: resolve => require(["@/view/user/index"], resolve),
                meta: {
                    title: "个人中心"
                }
            },
            {
                path: "/user/points",
                name: "Points",
                component: resolve => require(["@/view/user/points/index"], resolve),
                meta: {
                    title: '我的积分'
                }
            },
            {
                path: "/user_main",
                component: resolve => require(["@/view/user/UserMain.vue"], resolve),
                meta: {
                    title: "轩卓博客-一个专注于技术分享的博客平台"
                }
            },
            {
                path: "/version",
                component: resolve => require(["@/view/version/index.vue"], resolve),
                meta: {
                    title: "轩卓博客-一个专注于技术分享的博客平台"
                }
            },
            {
                path: "mall",
                name: "PointsMall",
                component: resolve => require(["@/view/points/mall/index"], resolve),
                meta: {
                    title: '积分商城'
                }
            },
            {
                path: "exchange",
                name: "PointsExchange",
                component: resolve => require(["@/view/points/exchange/index"], resolve),
                meta: {
                    title: '兑换记录'
                }
            },
            {
                path: '/column',
                name: 'column',
                component: resolve => require(["@/view/column/index"], resolve),
                meta: { title: '专栏', icon: 'el-icon-collection' }
            },
            {
                path: '/column/:id',
                name: 'columnDetail',
                component: resolve => require(["@/view/column/detail"], resolve),
                meta: { title: '专栏详情', icon: 'el-icon-collection' }
            },
            {
                path: "/question/category/:id",
                component: resolve => require(["@/view/question/QuestionCategory"], resolve),
                meta: {
                    title: "分类题目"
                }
            },
            {
                path: '/question/detail/:id',
                name: 'QuestionDetail',
                component: resolve => require(["@/view/question/QuestionDetail"], resolve),
                meta: { title: '题目详情' },
                hidden: true
            },
            {
                path: '/question/practice/:id',
                name: 'QuestionPractice',
                component: resolve => require(["@/view/question/QuestionPractice"], resolve),
                meta: { title: '题目练习' },
                hidden: true
            },
            {
                path: '/question/wrongBook',
                name: 'WrongBook',
                component: resolve => require(["@/view/question/WrongBook"], resolve),
                meta: { title: '错题本' },
                hidden: true
            },
            {
                path: "/question/special",
                component: resolve => require(["@/view/question/QuestionHome"], resolve),
                meta: {
                    title: "专项练习"
                }
            },
            {
                path: "/question/all",
                component: resolve => require(["@/view/question/QuestionBank"], resolve),
                meta: {
                    title: "全部题库"
                }
            },
            // AI助手相关路由
            {
                path: '/question/aiAssistant',
                name: 'AiAssistant',
                component: resolve => require(["@/view/question/AiAssistant.vue"], resolve),
                meta: { title: 'AI助手' }
            },
            {
                path: '/question/qa',
                component: resolve => require(["@/view/question/QA.vue"], resolve),
                name: 'JavaQA',
                meta: { title: 'Java知识问答' }
            },
            {
                path: '/question/interviewQuestion',
                component: resolve => require(["@/view/question/InterviewQuestion.vue"], resolve),
                name: 'InterviewQuestion',
                meta: { title: 'AI面试题生成' }
            },
            {
                path: '/question/interview',
                component: resolve => require(["@/view/question/interview/InterviewHub.vue"], resolve),
                name: 'InterviewHub',
                meta: { title: '简历面试' }
            },
            {
                path: '/question/resume/upload',
                component: resolve => require(["@/view/question/interview/ResumeUpload.vue"], resolve),
                name: 'ResumeUpload',
                meta: { title: '上传简历' }
            },
            {
                path: '/question/resume-builder',
                redirect: '/question/resume-builder/templates'
            },
            {
                path: '/question/resume-builder/templates',
                component: resolve => require(["@/view/question/resume-builder/TemplateList.vue"], resolve),
                name: 'ResumeBuilderTemplates',
                meta: { title: '简历制作' }
            },
            {
                path: '/question/resume-builder/mine',
                component: resolve => require(["@/view/question/resume-builder/MyResumes.vue"], resolve),
                name: 'ResumeBuilderMine',
                meta: { title: '我的在线简历' }
            },
            {
                path: '/question/resume-builder/:draftId/edit',
                component: resolve => require(["@/view/question/resume-builder/Editor.vue"], resolve),
                name: 'ResumeBuilderEditor',
                meta: { title: '在线简历编辑' },
                hidden: true
            },
            {
                path: '/question/resume-builder/:draftId/edit-workbench',
                component: resolve => require(["@/view/question/resume-builder/EditorWorkbench.vue"], resolve),
                name: 'ResumeBuilderEditorWorkbench',
                meta: { title: '新版简历编辑工作台' },
                hidden: true
            },
            {
                path: '/question/resume-builder/:draftId/preview',
                component: resolve => require(["@/view/question/resume-builder/Preview.vue"], resolve),
                name: 'ResumeBuilderPreview',
                meta: { title: '在线简历预览' },
                hidden: true
            },
            {
                path: '/question/resume/history',
                component: resolve => require(["@/view/question/interview/ResumeHistory.vue"], resolve),
                name: 'ResumeHistory',
                meta: { title: '简历库' }
            },
            {
                path: '/question/resume/:id',
                component: resolve => require(["@/view/question/interview/ResumeDetail.vue"], resolve),
                name: 'ResumeDetail',
                meta: { title: '简历详情' },
                hidden: true
            },
            {
                path: '/question/interview/resume/:resumeId?',
                component: resolve => require(["@/view/question/interview/InterviewSession.vue"], resolve),
                name: 'ResumeInterviewCreate',
                meta: { title: '创建模拟面试' },
                hidden: true
            },
            {
                path: '/question/interview/sessions',
                component: resolve => require(["@/view/question/interview/InterviewSessions.vue"], resolve),
                name: 'InterviewSessions',
                meta: { title: '面试记录' }
            },
            {
                path: '/question/voice-interview/sessions',
                component: resolve => require(["@/view/question/interview/VoiceInterviewSessions.vue"], resolve),
                name: 'VoiceInterviewSessions',
                meta: { title: '语音面试记录' }
            },
            {
                path: '/question/voice-interview/session',
                component: resolve => require(["@/view/question/interview/VoiceInterviewSession.vue"], resolve),
                name: 'VoiceInterviewSession',
                meta: { title: '语音模拟面试' },
                hidden: true
            },
            {
                path: '/question/voice-interview/report/:sessionId',
                component: resolve => require(["@/view/question/interview/VoiceInterviewReport.vue"], resolve),
                name: 'VoiceInterviewReport',
                meta: { title: '语音面试报告' },
                hidden: true
            },
            {
                path: '/question/knowledgebase',
                component: resolve => require(["@/view/question/interview/KnowledgeBase.vue"], resolve),
                name: 'KnowledgeBase',
                meta: { title: '面试知识库' }
            },
            {
                path: '/question/interview/session/:sessionId',
                component: resolve => require(["@/view/question/interview/InterviewSession.vue"], resolve),
                name: 'InterviewSession',
                meta: { title: '模拟面试' },
                hidden: true
            },
            {
                path: '/question/interview/session/:sessionId/detail',
                component: resolve => require(["@/view/question/interview/InterviewSessionDetail.vue"], resolve),
                name: 'InterviewSessionDetail',
                meta: { title: '面试复盘详情' },
                hidden: true
            },
            {
                path: '/question/interview/report/:sessionId',
                component: resolve => require(["@/view/question/interview/InterviewReport.vue"], resolve),
                name: 'InterviewReport',
                meta: { title: '面试报告' },
                hidden: true
            },
            {
                path: '/pushDetail/:id?',
                name: 'PushDetail',
                component: resolve => require(["@/view/push/pushDetail"], resolve),
                meta: {title: '推送详情'}
            }, {
                path: '/blessings',
                component: resolve => require(["@/view/blessings/index.vue"], resolve),
                meta: {title: '暖心祝福'}
            }
            ],
    },
    {
        path: "*",
        name: "NotFound",
        component: () => import("@/view/404/404.vue"),
    }
];

const router = new VueRouter({
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    routes
});
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
export default router;
